module.exports = __webpack_public_path__ + "static/media/learning-7.94083e24.png";